module.exports = __webpack_public_path__ + "img/Woveon1.4aa044d6.svg";